import { render, staticRenderFns } from "./ViewShowImage.vue?vue&type=template&id=30f5c1d4&scoped=true&"
import script from "./ViewShowImage.vue?vue&type=script&lang=js&"
export * from "./ViewShowImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30f5c1d4",
  null
  
)

export default component.exports